import { useState, useContext } from 'react';
import AppContext from './../contexts/AppContext';
import DataContext from './../contexts/DataContext';
import { isMobile } from './../helpers';
import ConfigContext from '../contexts/ConfigContext';
import { useNavigate } from 'react-router-dom';

export default function ButtonQuestion({
  name,
  icon,
  iconHover,
  className,
  value,
  optionKey,
  selected,
  isTextIcon = false,
  isMobileFriendly = false,
}: any) {
  const [hover, setHover] = useState(false);
  const { updateSelectedOption, goToNextSlide } = useContext(AppContext);
  const { data, updateData } = useContext(DataContext);
  const { features } = useContext(ConfigContext);
  const navigate = useNavigate();

  const handleClick = () => {
    switch (optionKey) {
      case 'property':
        if (value === 'Condo / Apartment' || value === 'Mobile Home') {
          // window.location.href = `/${process.env
          //   .REACT_APP_ROOT_PATH!}?renter=yes`;
          navigate(`/?renter=yes`);
          return;
        }
        dataLayer.push({
          event: 'seform_property_you_own',
          event_action: 'What kind of property do you own?',
          event_label: value,
        });
        break;
      case 'sunlight':
        dataLayer.push({
          event: 'seform_sunlight_your_roof_get',
          event_action: 'How much sunlight does your roof get?',
          event_label: value,
        });
        break;
    }

    const newData: any = { ...data };
    newData[optionKey] = value;
    updateData(newData);
    updateSelectedOption(optionKey, value);

    setTimeout(() => {
      goToNextSlide();
    }, 250);
  };

  const getZukoId = () => {
    return `${(optionKey + '_' + name.split(' ').join('_')).toLowerCase()}`;
  };
  const renderMobileFriendlyButton = () => {
    return (
      <button
        type="button"
        className={`flex flex-col items-center justify-center p-4 border rounded-lg shadow-sm ${
          selected ? 'bg-[#5ecf7f] border-[#5ecf7f]' : ''
        }`}
        onClick={handleClick}
        data-zuko-id={getZukoId()}>
        <div className="">
          <img
            className="w-[32px] h-[32px]"
            src={hover || selected ? iconHover : icon}
            alt={name}
          />
        </div>
        <p className={`text-[15px] mt-4 ${selected ? 'text-white' : ''}`}>
          {name}
        </p>
      </button>
    );
  };

  return isMobileFriendly && isMobile() ? (
    renderMobileFriendlyButton()
  ) : features.showSunnyBot ? (
    <button
      type="button"
      className={`flex flex-col items-center justify-center w-[150px] h-[96px] short:h-[96px] md:h-[110px] border-[#DCDCD6] border rounded-[8px] short:mb-4 ${
        selected || hover ? 'bg-gray-100' : ''
      } ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleClick}
      data-zuko-id={getZukoId()}>
      <img
        className={`w-[40px] md:w-12 h-[40px] short:h-[40px] md:h-12`}
        src={icon}
        alt={name}
      />
      <p className="text-[12px] md:text-[14px] mt-4">{name}</p>
    </button>
  ) : (
    <button
      type="button"
      className={`group flex flex-row md:flex-col md:basis-1/4 items-center grow ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleClick}
      data-zuko-id={getZukoId()}>
      <div
        className={`${
          isTextIcon
            ? 'w-[110px] short:w-[80px] md:w-[110px] h-[60px] short:h-[80px] md:h-[110px]'
            : 'w-[64px] md:w-[90px] h-[64px] md:h-[90px]'
        } md:group-hover:bg-[#3c3c3c] rounded-full flex justify-center items-center transition-colors duration-500 ${
          selected ? 'bg-[#3c3c3c]' : 'bg-[#F4F3F0]'
        }`}>
        <img
          className={`${
            isTextIcon
              ? 'w-full h-[14px] short:h-[12px] md:h-[16px]'
              : 'w-[32px] md:w-10 h-[32px] md:h-10'
          } md:group-hover:stroke-white`}
          src={hover || selected ? iconHover : icon}
          alt={name}
        />
      </div>
      <p className="text-[17px] short:text-[14px] ml-[18px] md:ml-0 md:mt-4">
        {name}
      </p>
    </button>
  );
}
